import CookiesEuBanner from "cookies-eu-banner";
import "cookies-eu-banner/css/cookies-eu-banner.default.css";

$(document).on("turbolinks:load", function () {
  new CookiesEuBanner(() => {}, true);
});
